export default function XIcon({ width = 35, height = 35, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 35 35"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M20.8332 14.8218L33.8648 0H30.7778L19.4577 12.8669L10.423 0H0L13.6652 19.4589L0 35H3.087L15.0337 21.4092L24.577 35H35M4.20117 2.27777H8.94367L30.7755 32.8341H26.0318"
                fill="#EAEAEA"
            />
        </svg>
    );
}
